class ZeptoPreviewModal extends HTMLElement {
  constructor() {
    super();
    this.modalOverlay = null;
    this.isImageUrl = this.isImageUrl.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeydown);
    if (this.modalOverlay) {
      this.modalOverlay.remove();
    }
  }

  init() {
    const previewLinks = this.querySelectorAll('.zepto-preview-link');
    
    previewLinks.forEach(link => {
      const href = link.getAttribute('href');
      
      if (this.isImageUrl(href)) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.openModal(href, link.textContent || 'Preview');
        });
        
        link.style.cursor = 'pointer';
        link.setAttribute('data-preview-type', 'image');
      }
    });

    this.createModalOverlay();
    document.addEventListener('keydown', this.handleKeydown);
  }

  isImageUrl(url) {
    if (!url) return false;
    
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
    
    return imageExtensions.test(url) || 
           url.includes('cdn.shopify.com') || 
           url.includes('/files/') ||
           url.includes('image') ||
           url.includes('img');
  }

  createModalOverlay() {
    this.modalOverlay = document.createElement('div');
    this.modalOverlay.className = 'zepto-modal-overlay';
    
    this.modalOverlay.innerHTML = `
      <div class="zepto-modal">
        <button class="zepto-modal-close" aria-label="Close preview">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <img class="zepto-modal-image" alt="Preview" />
        <div class="zepto-modal-caption"></div>
      </div>
    `;

    document.body.appendChild(this.modalOverlay);

    const closeBtn = this.modalOverlay.querySelector('.zepto-modal-close');
    closeBtn.addEventListener('click', this.closeModal);

    this.modalOverlay.addEventListener('click', (e) => {
      if (e.target === this.modalOverlay) {
        this.closeModal();
      }
    });
  }

  openModal(imageUrl, caption = '') {
    const modalImage = this.modalOverlay.querySelector('.zepto-modal-image');
    const modalCaption = this.modalOverlay.querySelector('.zepto-modal-caption');

    modalImage.src = imageUrl;
    modalImage.alt = caption;
    modalCaption.textContent = caption;

    this.modalOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';

    modalImage.onerror = () => {
      modalCaption.textContent = 'Failed to load image';
      modalImage.alt = 'Failed to load image';
    };
  }

  closeModal() {
    this.modalOverlay.classList.remove('open');
    document.body.style.overflow = '';

    setTimeout(() => {
      const modalImage = this.modalOverlay.querySelector('.zepto-modal-image');
      modalImage.src = '';
    }, 200);
  }

  handleKeydown(e) {
    if (e.key === 'Escape' && this.modalOverlay.classList.contains('open')) {
      this.closeModal();
    }
  }
}

customElements.define('zepto-preview-modal', ZeptoPreviewModal);